import QuickLink from './QuickLink';

export default QuickLink;
